<template>
  <bk-page class="recentlyPage" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-container" v-if="locInfo">
			<bk-scroll-list 
        ref="listScroll" 
        :beforeSearch="beforeSearch"  
        :async-load-data="requestGetShopBrowseRecently" 
        emptyType="noData" 
        langCode_description="userInfo_recently_description"
      >
        <template v-slot="{ dataList }">
					<bk-view class="view-recently-list">
						<bk-view class="view-recently-card" v-for="item in dataList" :key="item.id">
							<shopItem :item="item" />
						</bk-view>
					</bk-view>
				</template>
			</bk-scroll-list>
		</bk-view>
  </bk-page>
</template>

<script>
	import { shopReq } from '@/reqService';
	import shopItem from '@/pages/home/subViews/shopItem/shopItem';

	export default {
		name:'recently',
		components:{ shopItem },
		data (){
			return {
				curShop:this.$bk_getShopDetailInfo(),
				showPage:'',
				navBarInfo: {
					langCode_title:'userInfo_recently_title',
					backFlag: true,
				},
				locInfo:null
			};
		},
		created (){
			window.getCurrentPosition({
				callback: (e) => {
					console.log('定位结果：', e);

					if (e.success) {
						this.locInfo = e.locInfo || {
							lat: 31,
							lng: 121,
						};
					} else {
						this.locInfo = {
							lat: 31,
							lng: 121,
						};
					}
					
				}
			});
		},
		methods:{
			beforeSearch (params) {
				const { lat, lng } = this.locInfo;
				params.lng = lng;
				params.lat = lat;

				if(this.curShop?.custId){
          if(window.komoDZFlag || window.oblissDZFlag){
            params.custId = this.curShop?.custId;
          }
        }
				return params;
			},
			async requestGetShopBrowseRecently (params) {
				let res = await shopReq.requestGetShopBrowseRecently(this, params);
				return { data:res?.list, total: res?.page?.total };
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			handleItemClick (row){
				this.curItem = row;
				this.setShowPage('paymentDetail');
			}
		}
	};
</script>

<style lang="less">
@import './recently.less';
</style>